// Lightweight service client wrapper to centralize token headers and RequestInit typing

export function authHeaders(token: string, extra?: HeadersInit): HeadersInit {
  const base: HeadersInit = {
    Authorization: `Bearer ${token}`,
  };
  if (!extra) return base;
  // Merge while preserving existing header cases
  const result = new Headers();
  const appendAll = (h: HeadersInit) => {
    if (h instanceof Headers) {
      h.forEach((value, key) => result.append(key, value));
    } else if (Array.isArray(h)) {
      h.forEach(([key, value]) => result.append(key, value));
    } else if (h && typeof h === 'object') {
      Object.entries(h).forEach(([key, value]) => {
        if (typeof value !== 'undefined') result.append(key, String(value));
      });
    }
  };
  appendAll(base);
  appendAll(extra);
  return result;
}

export function withAuth(
  init: RequestInit | undefined,
  token: string,
  signal?: AbortSignal | null
): RequestInit {
  const base: RequestInit = init ? { ...init } : {};
  base.headers = authHeaders(token, base.headers as HeadersInit | undefined);
  // Enforce explicit null vs undefined for exactOptionalPropertyTypes
  base.signal = typeof signal === 'undefined' ? null : signal;
  return base;
}
